import { watch } from 'vue';

import { STATION_NUMBERS } from '@/stores/stations';

const FILTER_PARAM = 'filter';

const SHAREABLE_STATION_NUMBERS = new Set(STATION_NUMBERS);

function tokenToHost(token) {
  const number = Number(token);
  return Number.isInteger(number) && number >= 0 && number <= 255 ? `10.210.${number}.2` : null;
}

function hostToToken(host) {
  const match = host.match(/^10\.210\.(\d+)\.2$/);
  return match ? match[1] : null;
}

function isShareableHost(host) {
  const match = host.match(/^10\.210\.(\d+)\.2$/);
  if (!match) return false;
  return SHAREABLE_STATION_NUMBERS.has(Number(match[1]));
}

function readHostsFromUrl() {
  const searchParams = new URLSearchParams(window.location.search);
  const hasFilterParam = searchParams.has(FILTER_PARAM);
  const raw = searchParams.get(FILTER_PARAM);

  if (!raw) {
    return { hostsFromUrl: [], hasFilterParam };
  }

  return {
    hostsFromUrl: [
      ...new Set(
        raw
          .split(/[-,]/)
          .map((value) => tokenToHost(value.trim()))
          .filter(Boolean),
      ),
    ],
    hasFilterParam,
  };
}

function writeHostsToUrl(hosts) {
  const url = new URL(window.location.href);

  const tokens = hosts
    .filter((host) => isShareableHost(host))
    .map(hostToToken)
    .filter(Boolean);

  if (tokens.length > 0) {
    url.searchParams.set(FILTER_PARAM, tokens.join('-'));
  } else {
    url.searchParams.delete(FILTER_PARAM);
  }

  window.history.replaceState(window.history.state, '', url);
}

// eslint-disable-next-line import-x/prefer-default-export
export function useStationsFilterParam(selectedHosts) {
  const { hostsFromUrl, hasFilterParam } = readHostsFromUrl();

  if (hasFilterParam) {
    selectedHosts.value = hostsFromUrl;
  }

  watch(selectedHosts, writeHostsToUrl, { immediate: true });
}
